import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { themeGet } from '@primer/react';
import SliderArrow from '../../icons/SliderArrow.js';

var _excluded = ["children", "defaultExpanded", "onSliderChange", "position", "width", "defaultCollpaseWidth", "btnAriaLabel"];
var _templateObject, _templateObject2, _templateObject3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var Container = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n  height: 100%;\n  width: ", ";\n  transition: width 200ms;\n  ", ";\n  border-color: ", ";\n"])), function (_ref) {
  var isExpanded = _ref.isExpanded,
    width = _ref.width,
    defaultCollpaseWidth = _ref.defaultCollpaseWidth;
  return isExpanded ? "".concat(width + defaultCollpaseWidth, "px") : "".concat(defaultCollpaseWidth, "px");
}, function (_ref2) {
  var position = _ref2.position;
  return position === LTSectionSlider.POSITION.LEFT ? "border-right: 1px solid" : "border-left: 1px solid";
}, themeGet("colors.border.default"));
var Icon = styled.button(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  padding: 0;\n  border: none;\n  background: none;\n  cursor: pointer;\n  position: absolute;\n  top: 20px;\n  ", ";\n  z-index: 2;\n  ", ";\n"])), function (_ref3) {
  var position = _ref3.position;
  return position === LTSectionSlider.POSITION.LEFT ? "right: 0px" : "left: 0px";
}, function (_ref4) {
  var isExpanded = _ref4.isExpanded,
    position = _ref4.position;
  return position === "left" ? "transform:  ".concat(isExpanded ? "rotateY(180deg) translateX(-50%)" : "translateX(50%)", ";") : "transform:  ".concat(isExpanded ? "translateX(-50%)" : "rotateY(180deg)  translateX(50%)", ";");
});
var Content = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  transition: margin 1s;\n  padding-right: ", ";\n"])), function (_ref5) {
  var isExpanded = _ref5.isExpanded,
    defaultCollpaseWidth = _ref5.defaultCollpaseWidth;
  return isExpanded ? "0px" : "".concat(defaultCollpaseWidth, "px");
});
var LTSectionSlider = function LTSectionSlider(_ref6) {
  var _ref6$children = _ref6.children,
    children = _ref6$children === void 0 ? function () {} : _ref6$children,
    _ref6$defaultExpanded = _ref6.defaultExpanded,
    defaultExpanded = _ref6$defaultExpanded === void 0 ? false : _ref6$defaultExpanded,
    _ref6$onSliderChange = _ref6.onSliderChange,
    onSliderChange = _ref6$onSliderChange === void 0 ? function () {} : _ref6$onSliderChange,
    _ref6$position = _ref6.position,
    position = _ref6$position === void 0 ? LTSectionSlider.POSITION.LEFT : _ref6$position,
    _ref6$width = _ref6.width,
    width = _ref6$width === void 0 ? 300 : _ref6$width,
    _ref6$defaultCollpase = _ref6.defaultCollpaseWidth,
    defaultCollpaseWidth = _ref6$defaultCollpase === void 0 ? 16 : _ref6$defaultCollpase,
    _ref6$btnAriaLabel = _ref6.btnAriaLabel,
    btnAriaLabel = _ref6$btnAriaLabel === void 0 ? "" : _ref6$btnAriaLabel,
    rest = _objectWithoutProperties(_ref6, _excluded);
  var _useState = useState(defaultExpanded),
    _useState2 = _slicedToArray(_useState, 2),
    isExpanded = _useState2[0],
    setIsExpanded = _useState2[1];
  useEffect(function () {
    onSliderChange(isExpanded);
  }, [isExpanded]);
  var onKeyPress = function onKeyPress(event) {
    if (position === LTSectionSlider.POSITION.LEFT) {
      if (event.key === "ArrowLeft" || event.key === "Escape") {
        setIsExpanded(false);
      } else if (event.key === "ArrowRight") {
        setIsExpanded(true);
      }
    } else {
      if (event.key === "ArrowLeft") {
        setIsExpanded(true);
      } else if (event.key === "ArrowRight" || event.key === "Escape") {
        setIsExpanded(false);
      }
    }
  };
  return /*#__PURE__*/React.createElement(Container, _extends({
    isExpanded: isExpanded,
    onKeyDown: onKeyPress,
    position: position,
    role: "group",
    width: width,
    defaultCollpaseWidth: defaultCollpaseWidth
  }, rest), /*#__PURE__*/React.createElement(Icon, {
    "aria-label": btnAriaLabel,
    isExpanded: isExpanded,
    onClick: function onClick() {
      return setIsExpanded(!isExpanded);
    },
    position: position
  }, /*#__PURE__*/React.createElement(SliderArrow, null)), /*#__PURE__*/React.createElement(Content, {
    isExpanded: isExpanded,
    defaultCollpaseWidth: defaultCollpaseWidth
  }, children));
};
LTSectionSlider.displayName = "LTSectionSlider";
LTSectionSlider.POSITION = {
  LEFT: "left",
  RIGHT: "right"
};

export { LTSectionSlider as default };
